import React, { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useLocation } from "react-router-dom";
import Login from "./Login";

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = useIsAuthenticated();
    const { inProgress } = useMsal();
    const location = useLocation();

    useEffect(() => {
        if (!isAuthenticated) {
            const target = `${location.pathname}${location.search}${location.hash || ""}`;
            localStorage.setItem("postLoginRedirect", target);
        }
    }, [isAuthenticated, location.pathname, location.search, location.hash]);
    
    if (inProgress !== InteractionStatus.None) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center">
                <div className="text-white text-center">
                    <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white mb-4"></div>
                    <p className="text-lg">Authentifizierung läuft...</p>
                </div>
            </div>
        );
    }
    
    if (!isAuthenticated) {
        return <Login />;
    }
    
    return <>{children}</>;
};

export default ProtectedRoute;
